import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_ctx.isGranted('DOWNLOAD_POST_IMPORT_FILE'))
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.url
      }, [
        _createVNode(_component_q_btn, _mergeProps({
          icon: "fa fa-download",
          class: "text-dark",
          title: "Download file"
        }, _ctx.$attrs, { round: "" }), null, 16)
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}